module.exports = __webpack_public_path__ + "static/img/3_6_2.721e3cf3.jpg";